import React, { ReactNode } from 'react'
import { Grid } from '@mui/material'
import { DataGridSettings } from '../../interfaces/DataGrid/DataGridSettings'

interface DataGridRowProps {
  settings: DataGridSettings
  bgColor?: string
  children?: ReactNode
}

export const DataGridRow: React.FC<DataGridRowProps> = ({
  children,
  settings,
  bgColor
}) => {
  return (
    <Grid
      container
      direction='row'
      spacing={settings.spacing}
      style={{ backgroundColor: bgColor }}
    >
      {children}
    </Grid>
  )
}
